<div class="range top-left"></div>
<div class="range top-left2"></div>
<div class="range top-right"></div>
<div class="range top-right2"></div>
<div class="range bottom-left"></div>
<div class="range bottom-left2"></div>
<div class="range bottom-right"></div>
<div class="range bottom-right2"></div>